// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Interactive_modal-scroll__XDAHu","interactiveArea":"Interactive_interactiveArea__tx_LK","pointer":"Interactive_pointer__Fiwme"};